var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28018 0.883883C9.5146 0.649463 9.83254 0.517767 10.1641 0.517767C10.4956 0.517767 10.8135 0.649463 11.0479 0.883883L11.9318 1.76777C12.1662 2.00219 12.2979 2.32013 12.2979 2.65165C12.2979 2.98317 12.1662 3.30111 11.9318 3.53553L4.86076 10.6066L1.32523 11.4905L2.20911 7.95495L9.28018 0.883883Z",
    stroke: "#CD2A3F",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17578 2.43066L10.3855 4.64037",
    stroke: "#CD2A3F",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.80880f7c404402f8e671516fa9c8b019.svg";
export { ForwardRef as ReactComponent };